import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGhost, errMsg, inp, lbl } from "./ui";

export function LiveMatrix({ event, matrix, byCategory, total }) {
  return (
    <div className="overflow-x-auto" data-testid="att-live-matrix">
      <table className="w-full text-sm">
        <thead><tr className="border-b border-white/10 text-[10px] tracking-widest uppercase text-neutral-400">
          <th className="text-left py-3">Zone</th>{event.categories.map((c) => <th key={c.key} className="text-right px-2">{c.label}</th>)}<th className="text-right">Total</th>
        </tr></thead>
        <tbody>
          {event.zones.map((z) => {
            const row = matrix[z.id] || {};
            return (
              <tr key={z.id} className="border-b border-white/5">
                <td className="py-2.5 text-white">{z.name}</td>
                {event.categories.map((c) => <td key={c.key} className="text-right px-2 tabular-nums">{row[c.key] || 0}</td>)}
                <td className="text-right tabular-nums text-[#D4AF37]">{event.categories.reduce((s, c) => s + (row[c.key] || 0), 0)}</td>
              </tr>
            );
          })}
          <tr className="font-semibold"><td className="py-3 text-white">All zones</td>
            {event.categories.map((c) => <td key={c.key} className="text-right px-2 tabular-nums" data-testid={`att-cat-total-${c.key}`}>{byCategory[c.key] || 0}</td>)}
            <td className="text-right tabular-nums text-[#D4AF37]" data-testid="att-grand-total">{total}</td></tr>
        </tbody>
      </table>
    </div>
  );
}

export function AuditLog({ event, log }) {
  const zone = Object.fromEntries(event.zones.map((z) => [z.id, z.name]));
  const cat = Object.fromEntries(event.categories.map((c) => [c.key, c.label]));
  if (!log.length) return <p className="text-sm text-neutral-500">No activity yet.</p>;
  return (
    <ul className="space-y-1.5 text-xs max-h-80 overflow-y-auto pr-2" data-testid="att-audit-log">
      {log.map((l) => (
        <li key={l.op_id} className="flex gap-3 text-neutral-400">
          <span className="tabular-nums text-neutral-600">{new Date(l.ts).toLocaleTimeString("en-GB")}</span>
          <span className={l.delta > 0 ? "text-emerald-300" : "text-red-300"}>{l.delta > 0 ? `+${l.delta}` : l.delta}</span>
          <span className="text-neutral-200">{cat[l.category] || l.category}</span>
          <span>{zone[l.zone_id] || l.zone_id}</span>
          <span className="ml-auto truncate">{l.source === "admin" ? `✎ ${l.actor}: ${l.reason}` : l.actor}</span>
        </li>
      ))}
    </ul>
  );
}

export function CorrectionForm({ event, onDone }) {
  const [f, setF] = useState({ zone_id: event.zones[0].id, category: event.categories[0].key, delta: 1, reason: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/attendance/events/${event.id}/correct`, { ...f, delta: Number(f.delta) }); toast.success("Correction recorded"); setF({ ...f, reason: "" }); onDone(); }
    catch (err) { toast.error(errMsg(err, "Correction failed")); }
  };
  return (
    <form onSubmit={submit} className="grid grid-cols-2 gap-3" data-testid="att-correction-form">
      <div><label className={lbl}>Zone</label><select className={inp} data-testid="att-corr-zone" value={f.zone_id} onChange={set("zone_id")}>{event.zones.map((z) => <option key={z.id} value={z.id}>{z.name}</option>)}</select></div>
      <div><label className={lbl}>Category</label><select className={inp} data-testid="att-corr-category" value={f.category} onChange={set("category")}>{event.categories.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}</select></div>
      <div><label className={lbl}>Change (+/−)</label><input type="number" required className={inp} data-testid="att-corr-delta" value={f.delta} onChange={set("delta")} /></div>
      <div><label className={lbl}>Reason *</label><input required minLength={3} className={inp} data-testid="att-corr-reason" value={f.reason} onChange={set("reason")} placeholder="e.g. late arrivals" /></div>
      <button className={`${btnGhost} col-span-2`} data-testid="att-corr-submit">Apply correction</button>
    </form>
  );
}
